import { PurchaseChannel } from "@redotech/redo-model/warranties";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoRadioGroup } from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { Flex } from "@redotech/redo-web/flex";
import { LoadingRedoAnimation } from "@redotech/redo-web/loading-redo-animation";
import { memo } from "react";
import { Header } from "./header";
import { useRegister } from "./use-register";
export const Register = memo(function Register({
  onBack,
  channelFilter,
  toRetailRegistration,
  toOnlineRegistration,
}: {
  onBack: (() => void) | undefined;
  channelFilter?: PurchaseChannel;
  toRetailRegistration: (channelName: string) => void;
  toOnlineRegistration: (channelName: string) => void;
}) {
  const {
    texts,
    purchaseChannelOptions,
    continueDisabled,
    isOtherOptionSelected,
    selectedPurchaseOptionId,
    otherPurchaseChannel,
    showLoading,
    setOtherPurchaseChannel,
    setSelectedPurchaseOptionId,
    onContinue,
  } = useRegister({
    toRetailRegistration,
    toOnlineRegistration,
    channelFilter,
  });
  if (showLoading) {
    return <LoadingRedoAnimation />;
  }
  return (
    <Flex flexDirection="column" gap="3xl">
      <Header
        leftAlign
        logo={undefined}
        merchantName={texts.merchantName}
        onBack={onBack}
        subtitle={texts.subtitle}
        title={texts.title}
      />
      <Flex flexDirection="column" gap="lg">
        <RedoRadioGroup
          bordered
          options={purchaseChannelOptions}
          setValue={(value) => setSelectedPurchaseOptionId(value)}
          size="sm"
          value={selectedPurchaseOptionId}
        />
        {isOtherOptionSelected && (
          <RedoTextInput
            label="Please specify"
            placeholder="Enter retailer name"
            setValue={setOtherPurchaseChannel}
            value={otherPurchaseChannel}
          />
        )}
      </Flex>
      <RedoButton
        disabled={continueDisabled}
        hierarchy="primary"
        onClick={onContinue}
        size="md"
        text={texts.continueButtonText}
      />
    </Flex>
  );
});
